module.exports = __webpack_public_path__ + "img/snpark_gallery3.bcb54af0.jpg";